import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "adultInfoWrapper",
  class: "flex-col view-wrapper"
}
const _hoisted_2 = {
  id: "expCheckin",
  class: "flex-col page-header"
}
const _hoisted_3 = {
  id: "infoForm",
  class: "flex-col"
}
const _hoisted_4 = { class: "form-wrapper" }
const _hoisted_5 = { class: "flex-row gap-8 flex-align-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_yes_no_input = _resolveComponent("yes-no-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "back-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "info-header flex-col" }, [
          _createElementVNode("div", { class: "form-title bold" }, "Minors?")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.adultsOnlyConsent)
              ? (_openBlock(), _createBlock(_component_yes_no_input, {
                  key: 0,
                  label: `Do you need to fill out a waiver for any minors${_ctx.adultAge ? ` under ${_ctx.adultAge} years old` : ''}?`,
                  yesBtn: { selected: _ctx.addingMinors },
                  onOnStatusChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addingMinors = $event))
                }, null, 8, ["label", "yesBtn"]))
              : _createCommentVNode("", true)
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", null, null, -1))
        ]),
        _createElementVNode("button", {
          class: "form-submit-btn",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onNext()), ["stop"]))
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("span", null, "Next", -1)
        ])),
        (_ctx.hasCheckins)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "form-btn",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.editCompleted()), ["stop"]))
            }, "View Completed Waivers"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}